import is from 'is_js';
import { List } from 'immutable';
import { actions as Session } from 'data/SessionPlans';
import { isActive as isActiveGroupStatus } from 'containers/Group/status';
import { actions as groupActions } from 'containers/Group';

export const shouldDisabledSkillName = 'Speaking';

export function getProgressTestPlanFromIndex(state, groupId, progressTestIndex, isUnitQuiz) {
  const currentProgressTestPlan =
    state
      .get('rootReducer')
      .get('progressTestsPlan')
      .get(groupId) &&
    state
      .get('rootReducer')
      .get('progressTestsPlan')
      .get(groupId)
      .data &&
    state
      .get('rootReducer')
      .get('progressTestsPlan')
      .get(groupId)
      .data
      .find((ptp) => ptp.isUnitQuiz === isUnitQuiz &&
        ptp.index === Number.parseInt(progressTestIndex, 10));
  return currentProgressTestPlan;
}

export function getDefaultProgressTest(state, groupId, isUnitQuiz) {
  try {
    const progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId).data;
    return progressTestsPlan.find((ptp) => ptp.isUnitQuiz === isUnitQuiz &&
      ptp.isCurrentProgressTest);
  } catch (e) {
    return null;
  }
}

export function getDefaultProgressTestIndex(state, groupId, isUnitQuiz) {
  const progressTest = getDefaultProgressTest(state, groupId, isUnitQuiz);
  return progressTest && progressTest.index;
}

export function getDefaultProgressReportId(state, groupId) {
  try {
    return getDefaultProgressTest(state, groupId, true).progressReportId;
  } catch (e) {
    return null;
  }
}

export function isMarkable(state, groupId, progressTestIndex, isUnitQuiz) {
  const group = state.get('rootReducer').get('groups').get(groupId) &&
    state.get('rootReducer').get('groups').get(groupId).data;
  const progressTestPlan =
    state.get('rootReducer').get('progressTestsPlan').get(groupId);
  const currentProgressTestPlan = progressTestPlan &&
    progressTestPlan.data &&
    progressTestPlan.data.find((ptp) => ptp.isUnitQuiz === isUnitQuiz &&
      ptp.index === Number.parseInt(progressTestIndex, 10));

  if (! is.existy(group) || ! is.existy(progressTestPlan) || ! is.existy(currentProgressTestPlan)) {
    return false;
  }
  const { status } = group;
  let { sessionPlans } = group;
  sessionPlans = sessionPlans.update('data', (data) =>
    data.map((sessionPlanId) => state.get('rootReducer')
      .get('sessionPlans')
      .get(sessionPlanId)));
  sessionPlans = sessionPlans.update('data', (data) => new List(data));
  const defaultSession = Session.getDefaultSession(state, groupId);

  if (! isActiveGroupStatus(status)) {
    return false;
  }

  if (! isUnitQuiz) {
    return true;
  }

  if (defaultSession.isFuture()) {
    return false;
  }

  const unitSessions = sessionPlans.data.filter((sp) =>
    Array.isArray(sp.unitIds) && currentProgressTestPlan.unitIds.includes(sp.unitIds[0])
  );

  const startedSessions = unitSessions && unitSessions.filter(
      (sp) => sp.index <= defaultSession.index
    );

  return startedSessions && startedSessions.size !== 0;
}

export function checkIsUnitQuiz(currentLocationPathName) {
  return currentLocationPathName && currentLocationPathName.search('progress-test') >= 0;
}

export function getViewerLink(state, progressTestId) {
  return state.get('rootReducer').get('progressTestViewLink') &&
    state.get('rootReducer').get('progressTestViewLink').get(`${progressTestId}`);
}

export function hasMidtermOrFinalExam(state, groupId) {
  const progressTestsPlan = state.get('rootReducer').get('progressTestsPlan').get(groupId);

  return progressTestsPlan && progressTestsPlan.data &&
    progressTestsPlan.data.find((ptp) => ptp.isUnitQuiz === false);
}

export function isCNOWNCentre(state, groupId) {
  const { countryCode, businessLineCode } = groupActions.getCentre(state, groupId);

  if (is.not.string(countryCode) || is.not.string(businessLineCode)) {
    return false;
  }

  return countryCode.concat(businessLineCode).toUpperCase() === 'CNOWN';
}



// WEBPACK FOOTER //
// ./data/ProgressTestsPlan/accessors.js